import { usePage } from '@inertiajs/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useLocale } from '../../../Shared/locale';
import { Project } from '../../../Shared/types';
import { Card } from '../../../Shared/UI/Card';
import { useRouter } from '../../router';
import { PageProps } from '../../types';
import ProjectLogo from './ProjectLogo';

export default function ProjectCard({
  project,
}: {
  project: Project;
}) {
  const { t } = useTranslation();
  const { charity } = usePage<PageProps>().props;
  const { formatCurrency } = useLocale();
  const { routes } = useRouter();

  const muted = !project.enabled && 'opacity-50';

  return (
    <Card
      spacing="xs"
      link={{
        href: routes.project_page(project.id),
      }}
    >
      <div className="grid grid-cols-[32px_8fr_4fr_5fr_3fr] gap-4 items-center">
        <div className={classNames(muted)}>
          <ProjectLogo project={project} charity={charity} />
        </div>
        <div className="min-w-0">
          <h4 className={classNames(muted, 'whitespace-nowrap overflow-hidden text-ellipsis')}>
            {project.title}
          </h4>
        </div>
        <div className={classNames(muted, 'text-sm')}>
          <span className="font-medium">
            {project.campaigns_count}
          </span>
          {' '}
          {t('backend:campaigns', { count: project.campaigns_count }).toLowerCase()}
        </div>
        <div className={classNames(muted, 'text-sm')}>
          <span className="font-medium">
            {formatCurrency(project.funds_raised)}
          </span>
          {' '}
          {t('backend:raised').toLowerCase()}
        </div>
        <div className={classNames('text-right text-sm font-medium', project.enabled ? 'text-emerald-600' : 'text-slate-500')}>
          {project.enabled ? t('backend:live') : t('backend:offline')}
        </div>
      </div>
    </Card>
  );
}
